import React, { lazy } from 'react';
const bonuses = [{
  num: '1',
  title: 'Banco de Rúbricas Listas para Usar',
  value: '$19',
  img: 'https://cdn.magicpatterns.com/uploads/kEWfLkDe1SfEZXYJw12suw/Bono_arte_1.webp'
}, {
  num: '2',
  title: 'Calendario Escolar del Arte 2026',
  value: '$27',
  img: 'https://cdn.magicpatterns.com/uploads/jz2Jwg7fyzWbggnZX7Rxpe/bono_arte_2.webp'
}, {
  num: '3',
  title: 'Guía de Arte con Materiales Económicos',
  value: '$38',
  img: 'https://cdn.magicpatterns.com/uploads/5ENjdaq4ywfYoCvFrQJDHN/bono_arte_3.webp'
}, {
  num: '4',
  title: 'Grandes Artistas Latinoamericanos',
  value: '$19',
  img: 'https://cdn.magicpatterns.com/uploads/jW3wKXCT8y6Qj6EgfXsJSU/bono_arte_4.webp'
}, {
  num: '5',
  title: 'Plantillas de Portafolio del Alumno',
  value: '$37',
  img: 'https://cdn.magicpatterns.com/uploads/7Cv5d2gvmer2CJ5FAiq1Ma/bono_arte_5.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-13">
            🎁 5 Bonos Exclusivos
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-14">
            Valorados en{' '}
            <span className="line-through text-secondary" data-id="element-15">$140 USD</span> —
            Incluidos <span className="font-bold text-primary" data-id="element-16">GRATIS</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light flex flex-col shadow-sm overflow-hidden transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-18">
              <div className="relative aspect-[4/3] bg-bg-main overflow-hidden" data-id="element-19">
                <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-20" />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center font-serif font-black text-lg shadow-md" data-id="element-21">
                  {bonus.num}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-22">
                <p className="text-text-sec text-xs font-bold uppercase tracking-wider mb-1" data-id="element-23">
                  Bono {bonus.num}
                </p>
                <h3 className="text-text-main font-bold text-lg leading-tight mb-3 flex-1" data-id="element-24">
                  {bonus.title}
                </h3>
                <div className="flex items-center gap-2 text-base" data-id="element-25">
                  <span className="text-secondary line-through font-medium" data-id="element-26">
                    {bonus.value}
                  </span>
                  <span className="text-primary font-bold" data-id="element-27">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}